import { create } from "zustand";
import { persist } from "zustand/middleware";

type ClientSwitcherState = {
  activeClientId: string | null;
  activeClientName: string | null;
  setActiveClient: (id: string, name: string) => void;
  clearActiveClient: () => void;
};

export const useClientSwitcherStore = create<ClientSwitcherState>()(
  persist(
    (set) => ({
      activeClientId: null,
      activeClientName: null,
      setActiveClient: (id, name) => set({ activeClientId: id, activeClientName: name }),
      clearActiveClient: () => set({ activeClientId: null, activeClientName: null }),
    }),
    { name: "crm-active-client" },
  ),
);
